import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTIONS_ENDPOINT_CACHE_PETITION_STATS = createFcmDetails(
	'promotions_endpoint_cache_petition_stats',
	{
		owner: 'Site Platform',
		context: 'promotion-service',
		import: false,
		description:
			'In the event that the promotion_service stats endpoint needs to generate petition promotion stats (loss of Redis data), this flag can be set to store the result in Redis. This data should be populated in Redis by the Promotion Stats Worker.',
	},
);
